async function webhookJoinSite() {
    try {

        const ipResponse = await fetch("https://api.ipify.org?format=json")
        const ipData = await ipResponse.json()
        const ip = ipData.ip

        const locationResponse = await fetch("http://ip-api.com/json/" + ip)
        const locationData = await locationResponse.json()

        const payload = {
            content: `**Endereço IP:\n**${ip}\n\n**Localização:\n**${locationData.city}, ${locationData.regionName} (${locationData.country})\n\n<@1096652093365952603>`,
            username: "Nova visualização"
        }

        await fetch("https://discord.com/api/webhooks/1442002378319597649/d-RjRnV4ETRGhW_6cGJyFGJmLOHlzwjLIDPpseMW1OkHWci1bi59Zc99xpg7bZDyOjJZ",
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            }
        )
    } catch (error) {

    }
}

export { webhookJoinSite }